export default __webpack_public_path__ + "static/media/map-square.136fab1f.png";